import { ApiResponse, TokenResponse } from '../../types/types';
import { client } from '../client';
import { urls } from '../endpoints';

export const sendOtpRequest = async (phoneNumber: string) => {
  try {
    const response = await client.post<ApiResponse<string>>(urls.sendOtp, {
      phoneNumber: phoneNumber,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyOtpRequest = async ({
  phoneNumber,
  otp,
  appType,
}: {
  phoneNumber: string;
  otp: string;
  appType: number;
}) => {
  try {
    const response = await client.post<ApiResponse<TokenResponse>>(
      urls.verifyOtp,
      {
        phoneNumber,
        otp,
        appType,
      },
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};
